import {
  TableCell,
  toCurrencyString,
  TableRow,
  Checkbox,
  toNumberString,
  CurrencyCode,
  Spinner,
} from '@client/toolkit';
import { NetYieldBuildingDetailReadModel } from '@client/api';
import Chip from '@mui/material/Chip';
import { colors } from '../../../../styles/color-tokens';
import { InputCell } from '../../../dashboard/dashboard-economy-view/components/InputCell/input-cell';
import { useTranslation } from 'react-i18next';
import { PercentChange } from '../../../dashboard/dashboard-economy-view/components/PercentageChange/percentage-change';
import { useBuildingFinancials } from '../../../../hooks/useBuildingFinancials';

export const BuildingRow = ({
  building,
  selectedRows,
  handleToggleSelect,
  handleKeyDownSelect,
  startDate,
  endDate,
}: {
  building: NetYieldBuildingDetailReadModel;
  selectedRows: Set<string>;
  handleToggleSelect: (id: string) => void;
  handleKeyDownSelect: (e: React.KeyboardEvent<Element>, id: string) => void;
  startDate?: string;
  endDate?: string;
}) => {
  const { t } = useTranslation('reporting');
  const { buildingDetail, operatingCost, setOperatingCost, propertyValue, setPropertyValue, isLoading, isFetching, handleSaveFinancials } =
    useBuildingFinancials(building, startDate, endDate);

  return (
    <TableRow className="bg-surface-elevated/40 border-b border-surface-elevated group hover:bg-surface-elevated">
      <TableCell className="content-center">
        <Checkbox
          checked={selectedRows.has(building.spaceId)}
          onChange={() => handleToggleSelect(building.spaceId)}
          tabIndex={0}
          aria-label={`Velg ${buildingDetail.name}`}
          onKeyDown={(e) => handleKeyDownSelect(e, building.spaceId)}
        />
      </TableCell>
      <TableCell>{buildingDetail.name}</TableCell>
      <InputCell
        className="px-2 py-2 float-left"
        value={operatingCost}
        onChange={setOperatingCost}
        onBlur={handleSaveFinancials}
        placeholder={t('netYield.placeholder')}
        disabled={isLoading || isFetching}
      />
      <TableCell>
        {toCurrencyString(buildingDetail.netIncomeAmount?.amount, '-', {
          currency: (buildingDetail.netIncomeAmount?.currency ?? 'NOK') as CurrencyCode,
          maximumFractionDigits: 0,
        })}
      </TableCell>
      <InputCell
        className="px-2 py-2 float-left"
        value={propertyValue}
        onChange={setPropertyValue}
        onBlur={handleSaveFinancials}
        placeholder={t('netYield.placeholder')}
        disabled={isLoading || isFetching}
      />
      <TableCell>
        {isLoading || isFetching ? (
          <Spinner size="sm" />
        ) : buildingDetail.netYield ? (
          toNumberString(buildingDetail.netYield)
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell>
        {isLoading || isFetching ? (
          <Spinner size="sm" />
        ) : buildingDetail.previousNetYield ? (
          toNumberString(buildingDetail.previousNetYield)
        ) : (
          '-'
        )}
      </TableCell>
      <TableCell className="float-left">
        {isLoading || isFetching ? (
          <Spinner size="sm" />
        ) : buildingDetail.percentChange !== null ? (
          <PercentChange value={buildingDetail.percentChange ?? 0} />
        ) : (
          <Chip
            label={t('netYield.noData')}
            size="small"
            sx={{ backgroundColor: colors.status.error, fontSize: '0.75rem', borderRadius: '0.4rem' }}
          />
        )}
      </TableCell>
    </TableRow>
  );
};
